import { figures, FigureId } from '../../data/figures';
import * as S from './styles';

export default function MetricSource({ id }: { id: FigureId }) {
  const figure = figures[id];
  return (
    <S.MetricDisclosure
      onKeyDown={event => {
        if (event.key === 'Escape') {
          event.currentTarget.open = false;
          event.currentTarget.querySelector('summary')?.focus();
        }
      }}
    >
      <summary aria-label={`${figure.value} ${figure.unit.toLowerCase()}. View source`}>
        <strong>{figure.value}</strong>
        <S.SourceIndicator aria-hidden="true">↗</S.SourceIndicator>
      </summary>
      <S.SourceNote>
        <p>
          {figure.receipt
            ?.replace(/^SOURCE: /, '')
            .replace(/(?:DOWNLOAD ↓|→)$/, '')
            .trim() ?? 'Project implementation records.'}
        </p>
        <p>Recorded {figure.asOf}.</p>
        {figure.receiptHref && (
          <a href={figure.receiptHref} target="_blank" rel="noopener noreferrer">
            {figure.receiptKind === 'document' ? 'Read the CV' : 'Open source'} ↗
          </a>
        )}
      </S.SourceNote>
    </S.MetricDisclosure>
  );
}
